import { HStack, Icon } from '@chakra-ui/react';
import { FiStar } from 'react-icons/fi';

export const StarRating = ({ rating = 0, max = 5, size = 4, color = 'yellow.400' }) => {
  return (
    <HStack spacing={0.5}>
      {Array.from({ length: max }).map((_, i) => (
        <Icon
          key={i}
          as={FiStar}
          boxSize={size}
          color={i < Math.round(rating) ? color : 'gray.300'}
          fill={i < Math.round(rating) ? color : 'none'}
        />
      ))}
    </HStack>
  );
};
